import { DIFFICULTY_LEVELS, QUESTION_TYPES } from '../questionTypes';

// 30 Preguntas del Músculo Deltoides
// 10 Básicas + 10 Generales + 10 Complejas

export const deltoidesQuestions = [
  
  // ========== NIVEL BÁSICO (10) ==========
  
  {
    id: 10061,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Cuántas porciones tiene el músculo deltoides?",
    options: ["Dos", "Tres", "Cuatro", "Cinco"],
    correctAnswer: 1,
    explanation: "El deltoides tiene tres porciones: anterior (clavicular), media (acromial) y posterior (espinal). Esta disposición triangular le da su forma característica y permite acciones variadas sobre el hombro. Es el músculo más superficial del hombro y uno de los más fuertes."
  },
  
  {
    id: 10062,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se origina la porción anterior del deltoides?",
    options: [
      "Acromion de la escápula",
      "Espina de la escápula",
      "Tercio lateral de la clavícula",
      "Tubérculo mayor del húmero"
    ],
    correctAnswer: 2,
    explanation: "La porción anterior del deltoides se origina en el tercio lateral de la clavícula. Esta inserción en el hueso clavicular le permite actuar como flexor y rotador interno del hombro, siendo sinergista del pectoral mayor."
  },
  
  {
    id: 10063,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cuál es la acción principal de la porción media del deltoides?",
    options: [
      "Flexión del hombro",
      "Abducción del hombro",
      "Extensión del hombro",
      "Rotación interna del hombro"
    ],
    correctAnswer: 1,
    explanation: "La porción media (acromial) del deltoides es el principal abductor del hombro. Puede abducir el brazo hasta 90 grados; por encima de este ángulo, el trapecio y serrato anterior toman el relevo. Su acción pura es perpendicular al brazo."
  },
  
  {
    id: 10064,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Qué nervio inerva al deltoides?",
    options: [
      "Nervio axilar",
      "Nervio radial",
      "Nervio musculocutáneo",
      "Nervio supraescapular"
    ],
    correctAnswer: 0,
    explanation: "El nervio axilar (C5-C6) inerva al deltoides. Este nervio sale de la axila posterior al húmero y es vulnerable a lesiones en luxaciones glenohumerales o fracturas del cuello quirúrgico del húmero, causando el típico 'signo del regador'."
  },
  
  {
    id: 10065,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué arteria irriga principalmente al deltoides?",
    options: [
      "Arteria axilar",
      "Arteria circunfleja humeral anterior",
      "Arteria circunfleja humeral posterior",
      "Arteria toracoacromial"
    ],
    correctAnswer: 1,
    explanation: "La arteria circunfleja humeral anterior, rama de la arteria axilar, irriga principalmente la porción anterior del deltoides. Las porciones media y posterior reciben irrigación de la arteria circunfleja humeral posterior. Esta vascularización dual explica la buena recuperación del músculo tras lesiones."
  },
  
  {
    id: 10066,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura anatómica se encuentra profunda al deltoides?",
    options: [
      "Piel únicamente",
      "Trapecio y romboides",
      "Manguito rotador",
      "Músculos de la espalda"
    ],
    correctAnswer: 2,
    explanation: "Los músculos del manguito rotador (supraespinoso, infraespinoso, subescapular, redondo menor) se encuentran profundos al deltoides. El deltoides actúa como puente protector sobre estos músculos más pequeños y vulnerables. La bursitis subdeltoidea ocurre en este espacio."
  },
  
  {
    id: 10067,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Dónde se inserta el tendón del deltoides?",
    options: [
      "Tubérculo mayor del húmero",
      "Tubérculo menor del húmero",
      "Tuberosidad deltoidea del húmero",
      "Cóndilos humerales"
    ],
    correctAnswer: 2,
    explanation: "El deltoides se inserta en la tuberosidad deltoidea (V deltoideo) en la cara lateral del húmero. Esta inserción en V explica por qué el músculo tiene forma triangular y permite sus múltiples acciones sobre el hombro."
  },
  
  {
    id: 10068,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se origina la porción posterior del deltoides?",
    options: [
      "Acromion",
      "Espina de la escápula",
      "Tercio lateral de la clavícula",
      "Apófisis coracoides"
    ],
    correctAnswer: 1,
    explanation: "La porción posterior del deltoides se origina en la espina de la escápula. Esta inserción espinal le permite actuar como extensor y rotador externo del hombro, siendo antagonista de la porción anterior."
  },
  
  {
    id: 10069,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Qué porción del deltoides actúa como extensor del hombro?",
    options: [
      "Porción anterior",
      "Porción media",
      "Porción posterior",
      "Todas las porciones"
    ],
    correctAnswer: 2,
    explanation: "La porción posterior del deltoides es la principal extensora del hombro. Actúa especialmente en movimientos como tirar, nadar estilo espalda, o alinear el brazo hacia atrás. Es importante en atletas de lanzamiento y deportes de contacto."
  },
  
  {
    id: 10070,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Por qué el deltoides es importante para la estabilidad del hombro?",
    options: [
      "Por su gran tamaño",
      "Por su función como puente muscular",
      "Por su inserción en el húmero",
      "Por su inervación única"
    ],
    correctAnswer: 1,
    explanation: "El deltoides actúa como puente muscular que protege y estabiliza los músculos del manguito rotador subyacentes. Su contracción crea una fuerza compresiva sobre la articulación glenohumeral, mejorando la estabilidad articular especialmente durante movimientos activos."
  },
  
  // ========== NIVEL GENERAL (10) ==========
  
  {
    id: 10071,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cómo contribuye el deltoides completo a la abducción del hombro?",
    options: [
      "Solo la porción media actúa",
      "Todas las porciones contribuyen",
      "Solo las porciones anterior y posterior",
      "La porción posterior antagoniza"
    ],
    correctAnswer: 1,
    explanation: "Todas las porciones del deltoides contribuyen a la abducción del hombro, pero de manera diferente: la porción media es la principal (0-90°), mientras que anterior y posterior estabilizan y asisten en rangos mayores. Esta acción coordinada explica la fuerza del deltoides en la abducción."
  },
  
  {
    id: 10072,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué músculos actúan como sinergistas del deltoides en la abducción?",
    options: [
      "Pectoral mayor y dorsal ancho",
      "Supraespinoso y trapecio",
      "Serrato anterior y trapecio",
      "Redondo mayor y subescapular"
    ],
    correctAnswer: 1,
    explanation: "El supraespinoso (manguito rotador) y trapecio actúan como sinergistas del deltoides en la abducción inicial del hombro. El supraespinoso inicia la abducción (0-15°) y el deltoides continúa hasta 90°. El trapecio asiste en abducción por encima de 90°."
  },
  
  {
    id: 10073,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué rama específica de la arteria toracoacromial irriga al deltoides?",
    options: [
      "Rama acromial",
      "Rama clavicular",
      "Rama deltoidea",
      "Rama pectoral"
    ],
    correctAnswer: 2,
    explanation: "La rama deltoidea de la arteria toracoacromial irriga específicamente el deltoides. Esta arteria emerge del pedículo toracoacromial y se anastomosa con las arterias circunflejas humerales, creando un rico plexo vascular alrededor del hombro."
  },
  
  {
    id: 10074,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Cómo se distribuye la inervación del nervio axilar en el deltoides?",
    options: [
      "Inerva todas las porciones por igual",
      "Inerva principalmente la porción posterior",
      "Inerva todas las porciones desde atrás",
      "Inerva porción media primero, luego anterior y posterior"
    ],
    correctAnswer: 0,
    explanation: "El nervio axilar inerva todas las porciones del deltoides de manera uniforme. Emerge de la división posterior del plexo braquial y rodea el cuello quirúrgico del húmero por detrás, donde es vulnerable a lesiones por fracturas o luxaciones."
  },
  
  {
    id: 10075,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VARIANTE,
    question: "¿Cuál es la variante más común del músculo deltoides?",
    options: [
      "Ausencia congénita",
      "Cabeza accesoria",
      "Inserción doble",
      "Fusión con trapecio"
    ],
    correctAnswer: 1,
    explanation: "La presencia de una cabeza accesoria (cabeza humeral) es la variante más común del deltoides, ocurriendo en 15-20% de la población. Esta cabeza adicional se origina del húmero proximal y se une al tendón principal, aumentando la fuerza del músculo."
  },
  
  {
    id: 10076,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué test clínico evalúa específicamente la función del deltoides?",
    options: [
      "Test de abducción resistida",
      "Test de Jobe",
      "Test de Neer",
      "Test de Hawkins"
    ],
    correctAnswer: 0,
    explanation: "El test de abducción resistida evalúa la integridad del deltoides. El paciente abduce el brazo a 90° contra resistencia aplicada en la cara lateral del brazo. Debilidad indica lesión del nervio axilar o ruptura del tendón deltoideo (rara)."
  },
  
  {
    id: 10077,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.EMBRIOLOGIA,
    question: "¿De qué masa muscular embrionaria se desarrolla el deltoides?",
    options: [
      "Masa deltoidea dorsal",
      "Masa flexora ventral",
      "Masa extensora dorsal",
      "Masa abductora lateral"
    ],
    correctAnswer: 0,
    explanation: "El deltoides se desarrolla de la masa muscular deltoidea dorsal del miembro superior, alrededor de la 5-6 semana de gestación. Esta masa da origen también al vasto lateral del cuádriceps, explicando su inervación común por nervios similares."
  },
  
  {
    id: 10078,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.HISTOLOGIA,
    question: "¿Qué proporción aproximada de fibras musculares tiene el deltoides?",
    options: [
      "90% fibras tipo I",
      "70% fibras tipo II",
      "60% tipo I, 40% tipo II",
      "40% tipo I, 60% tipo II"
    ],
    correctAnswer: 3,
    explanation: "El deltoides tiene predominio de fibras tipo II (60%), adaptadas para movimientos potentes y explosivos. Sin embargo, la proporción varía por porción: la posterior tiene más fibras tipo I (resistencia), mientras que la anterior tiene más tipo II (potencia)."
  },
  
  {
    id: 10079,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué espacio anatómico se encuentra entre el deltoides y la articulación glenohumeral?",
    options: [
      "Espacio cuadrangular",
      "Espacio triangular",
      "Espacio subdeltoideo",
      "Espacio axilar"
    ],
    correctAnswer: 2,
    explanation: "El espacio subdeltoideo contiene la bursa subdeltoidea y tendones del manguito rotador. Es un espacio potencial donde pueden ocurrir bursitis, tendinitis o conflictos subacromiales. La inyección subdeltoidea debe ser cuidadosa para evitar penetrar la articulación."
  },
  
  {
    id: 10080,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Por qué el deltoides es menos eficiente en abducción cuando el brazo está completamente extendido?",
    options: [
      "Por la contracción del pectoral mayor",
      "Por el ángulo de tracción del tendón",
      "Por la estabilización escapular",
      "Por la acción del trapecio"
    ],
    correctAnswer: 1,
    explanation: "Con el brazo completamente extendido, el ángulo de tracción del deltoides sobre el húmero es menos favorable, disminuyendo su eficiencia como abductor. La máxima eficiencia ocurre cuando el brazo forma un ángulo de 45-60° con el torso."
  },
  
  // ========== NIVEL COMPLEJO (10) ==========
  
  {
    id: 10081,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con antecedente de luxación glenohumeral presenta dolor lateral del hombro y debilidad para abducir. ¿Qué complicación sugiere?",
    options: [
      "Ruptura del supraespinoso",
      "Lesión del nervio axilar",
      "Tendinitis del deltoides",
      "Bursitis subacromial"
    ],
    correctAnswer: 1,
    explanation: "La lesión del nervio axilar es una complicación clásica de luxaciones glenohumerales anteriores. Causa parálisis del deltoides ('signo del regador'), pérdida de sensibilidad en el área deltoidea lateral, y debilidad para abducción. La recuperación es buena si no hay avulsión completa del nervio."
  },
  
  {
    id: 10082,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Paciente con dolor en la tuberosidad deltoidea y prueba de abducción dolorosa. ¿Cuál es el diagnóstico más probable?",
    options: [
      "Tendinitis del supraespinoso",
      "Inserciónitis del deltoides",
      "Conflicto subacromial",
      "Bursitis subdeltoidea"
    ],
    correctAnswer: 1,
    explanation: "La inserciónitis del deltoides (tendinitis de inserción) causa dolor localizado en la tuberosidad deltoidea. Es común en atletas que sobrecargan el hombro (levantadores de pesas, nadadores). Se trata con reposo, hielo, AINEs y fisioterapia. La infiltración local puede ser diagnóstica y terapéutica."
  },
  
  {
    id: 10083,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué abordaje se utiliza para reparar una ruptura completa del tendón del deltoides?",
    options: [
      "Abordaje deltopectoral",
      "Abordaje posterior",
      "Abordaje lateral del hombro",
      "Abordaje axilar"
    ],
    correctAnswer: 2,
    explanation: "El abordaje lateral del hombro permite acceso directo a la tuberosidad deltoidea para reparación tendinosa. Las rupturas completas del deltoides son raras y generalmente ocurren en el contexto de traumatismos severos o cirugía previa. Se repara con anclas o sutura transósea."
  },
  
  {
    id: 10084,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En RM del hombro, ¿qué hallazgo sugiere edema por denervación del deltoides?",
    options: [
      "Atrofia muscular difusa",
      "Aumento de señal en T2-STIR sin cambios estructurales",
      "Calcificaciones intratendinosas",
      "Líquido en la bursa subdeltoidea"
    ],
    correctAnswer: 1,
    explanation: "El edema por denervación del deltoides (lesión del nervio axilar) muestra aumento difuso de señal en T2-STIR sin cambios estructurales en el músculo. Es más sensible que la atrofia muscular, que aparece tardíamente. La electromiografía confirma la denervación."
  },
  
  {
    id: 10085,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué complicación puede causar una infiltración subdeltoidea mal realizada?",
    options: [
      "Lesión del manguito rotador",
      "Punción articular glenohumeral",
      "Lesión del nervio axilar",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "La infiltración subdeltoidea profunda puede penetrar accidentalmente la articulación glenohumeral, causando condritis química o infección articular. La aguja debe mantenerse superficial a la cápsula articular. La ecografía guiada reduce significativamente este riesgo."
  },
  
  {
    id: 10086,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con parálisis del deltoides post-cirugía de hombro. EMG muestra denervación completa. ¿Cuál es el pronóstico más probable?",
    options: [
      "Recuperación completa en 3 meses",
      "Parálisis permanente",
      "Recuperación parcial en 6-12 meses",
      "No hay recuperación posible"
    ],
    correctAnswer: 2,
    explanation: "La lesión completa del nervio axilar tiene buen pronóstico si es neurapraxia (recuperación en 3-6 meses) o neurotmesis parcial. La recuperación funcional del deltoides ocurre en 6-12 meses. La exploración quirúrgica está indicada si no hay recuperación electrofisiológica a los 3-4 meses."
  },
  
  {
    id: 10087,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Evaluación isocinética muestra déficit selectivo de abducción explosiva del hombro. ¿Qué porción del deltoides está afectada?",
    options: [
      "Porción anterior",
      "Porción media",
      "Porción posterior",
      "Todas las porciones"
    ],
    correctAnswer: 1,
    explanation: "La porción media del deltoides es la más activa en movimientos explosivos de abducción. Contiene mayor proporción de fibras tipo IIb. Las porciones anterior y posterior contribuyen más a movimientos de velocidad moderada y estabilización. La evaluación isocinética permite cuantificar déficits específicos."
  },
  
  {
    id: 10088,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué técnica se utiliza para transferir tendón en parálisis completa del deltoides?",
    options: [
      "Transferencia del trapecio",
      "Transferencia del dorsal ancho",
      "Transferencia del pectoral mayor",
      "Transferencia del bíceps braquial"
    ],
    correctAnswer: 0,
    explanation: "La transferencia del trapecio inferior (parte superior del dorsal ancho) al deltoides paralizado restaura la abducción del hombro. El trapecio se transfiere a través de un túnel óseo en el acromion y se inserta en el húmero. Esta técnica es efectiva para parálisis del nervio axilar no recuperables."
  },
  
  {
    id: 10089,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En ecografía del hombro, ¿qué maniobra confirma conflicto subdeltoideo?",
    options: [
      "Abducción pasiva del hombro",
      "Compresión dinámica del espacio subacromial",
      "Rotación interna del hombro",
      "Flexión del codo"
    ],
    correctAnswer: 1,
    explanation: "La compresión dinámica del espacio subacromial durante ecografía reproduce dolor en conflicto subdeltoideo. El manguito rotador y bursa se comprimen contra el acromion durante movimientos. Es más sensible que la RM para evaluar síntomas mecánicos dinámicos."
  },
  
  {
    id: 10090,
    muscle: 'deltoides',
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Paciente con hipertrofia compensatoria del trapecio post-parálisis del deltoides. ¿Qué movimiento se compensa?",
    options: [
      "Flexión del hombro",
      "Abducción del hombro",
      "Rotación interna",
      "Todas las funciones deltoideas"
    ],
    correctAnswer: 1,
    explanation: "El trapecio compensa la abducción del hombro cuando el deltoides está paralizado. La parte superior del trapecio actúa como abductor, permitiendo elevación del brazo hasta 90°. Sin embargo, no puede compensar completamente la pérdida de fuerza y estabilidad del deltoides."
  }
];
